import { useForm } from "@inertiajs/react";
import Input from "@/components/inputs/Input";
import TextArea from "@/components/inputs/TextArea";
import Button from "@/components/buttons/Button";

export interface GenerateBriefFormProps {
  genre?: string;
  style_vibe?: string;
  commissioned_by?: string;
  media_type?: string;
  lyrical_themes?: string;
  reference_tracks?: string;
  custom_instructions?: string;
  cta: string;
  formTitle?: string;
  formDescription?: string;
}

const GenerateBriefForm: React.FC<GenerateBriefFormProps> = ({
  genre,
  style_vibe,
  commissioned_by,
  media_type,
  lyrical_themes,
  reference_tracks,
  custom_instructions,
  cta,
  formTitle,
  formDescription,
}) => {
  const { get, processing, errors, data, setData } = useForm({
    genre: genre,
    style_vibe: style_vibe,
    commissioned_by: commissioned_by,
    media_type: media_type,
    lyrical_themes: lyrical_themes,
    reference_tracks: reference_tracks,
    custom_instructions: custom_instructions,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    get("/briefs/preview");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="md:dark:bg-cream-950 flex w-full flex-col items-start justify-start gap-8 rounded-lg md:bg-white md:p-10 md:shadow"
    >
      <div className="flex flex-col gap-2">
        {formTitle && <h2 className="text-lg font-semibold">{formTitle}</h2>}
        {formDescription && (
          <p className="text-cream-700 dark:text-cream-300 font-light">
            {formDescription}
          </p>
        )}
      </div>
      <Input
        type="text"
        onChange={(e) => setData("genre", e.target.value)}
        value={data.genre}
        placeholder="Pop / Lofi"
        label="Genre"
        errors={errors.genre}
      />

      <Input
        type="text"
        onChange={(e) => setData("style_vibe", e.target.value)}
        value={data.style_vibe}
        placeholder="Cool / urgent / exciting"
        label="Style / Vibe"
        errors={errors.style_vibe}
      />

      <Input
        type="text"
        onChange={(e) => setData("commissioned_by", e.target.value)}
        value={data.commissioned_by}
        placeholder="Channel 4 / Nandos"
        label="Commissioned By"
        errors={errors.commissioned_by}
      />

      <Input
        type="text"
        onChange={(e) => setData("media_type", e.target.value)}
        value={data.media_type}
        placeholder="Advert / Trailer"
        label="Media Type"
        errors={errors.media_type}
      />

      <Input
        type="text"
        onChange={(e) => setData("lyrical_themes", e.target.value)}
        value={data.lyrical_themes}
        placeholder="Too hot, too spicy"
        label="Lyrical Themes"
        errors={errors.lyrical_themes}
      />

      <Input
        type="text"
        onChange={(e) => setData("reference_tracks", e.target.value)}
        value={data.reference_tracks}
        placeholder="A very lovely day - BnHl"
        label="Reference tracks"
        errors={errors.reference_tracks}
      />

      <TextArea
        label="Custom Instructions"
        errors={errors.custom_instructions}
        placeholder="Must repeat the key lyric 3 times each chorus"
        onChange={(e) => setData("custom_instructions", e.target.value)}
        value={data.custom_instructions}
      />

      <Button
        text={cta}
        disabled={processing}
        type="primary"
        className="self-end"
      />
    </form>
  );
};

export default GenerateBriefForm;
